"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  MultipleActionsFlight: ['multiple-actions-flight', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21.87,13.623a1.76,1.76,0,0,1,1.044.686,1.813,1.813,0,0,1,.3,1.433c-.061.276-.414,1.116-.783,1.116l-10.142,6.3a.624.624,0,0,1-.688-.02l-3.718-2.61a.343.343,0,0,1-.053-.483c.018-.022,1.62-1.434,1.62-1.434a.342.342,0,0,1,.331-.057l1.956,1.165,2.48-1.73-4.7-2.91a.427.427,0,0,1-.048-.6c.02-.024,1.217-.916,1.217-.916a.425.425,0,0,1,.4-.057l6.476,2.411,3-2.045A1.668,1.668,0,0,1,21.87,13.623Z', 'M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M10.555,10.888A5.251,5.251,0,0,0,.75,13.5v2.25H3l.75,7.5h3', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsLocation: ['multiple-actions-location', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18.75,15.437a.375.375,0,1,1-.375.375.374.374,0,0,1,.375-.375', 'M18.75,11.312a4.5,4.5,0,0,1,4.5,4.5c0,1.92-2.688,5.576-3.909,7.138a.75.75,0,0,1-1.182,0c-1.221-1.561-3.909-5.217-3.909-7.137A4.5,4.5,0,0,1,18.75,11.312Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71', 'M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M11.25,13.5a5.25,5.25,0,0,0-10.5,0v2.25H3l.75,7.5h4.5L9,15.75h2.25Z']],
  MultipleActionsCheck2: ['multiple-actions-check-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M10.555,10.888A5.251,5.251,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5l.323-3.233', 'M23.25,17.25a6,6,0,1,1-6-6', 'M23.25,12.749l-5.47,5.47a.749.749,0,0,1-1.06,0L15,16.5', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsCart: ['multiple-actions-cart', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,12l-2.82,7.756a.752.752,0,0,1-.7.494H14.358a.751.751,0,0,1-.69-.455l-1.607-4.5a.749.749,0,0,1,.689-1.045h9.682', 'M15.375,22.5a.375.375,0,1,1-.375.375.374.374,0,0,1,.375-.375', 'M19.125,22.5a.375.375,0,1,1-.375.375.374.374,0,0,1,.375-.375', 'M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M10.555,10.888A5.251,5.251,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5l.324-3.233', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsDownload: ['multiple-actions-download', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M10.555,10.888A5.251,5.251,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5l.323-3.232', 'M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z', 'M17.25 14.25L17.25 20.25', 'M17.25 20.25L15 18', 'M17.25 20.25L19.5 18', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsFlag: ['multiple-actions-flag', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M14.25 12.75H23.25V18.75H14.25z', 'M14.25 12.75L14.25 23.25', 'M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M11.25,13.5a5.25,5.25,0,0,0-10.5,0v2.25H3l.75,7.5h4.5L9,15.75h2.25Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsEdit1: ['multiple-actions-edit-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.63,14.869,15,22.5l-3.75.75L12,19.5l7.63-7.631a2.116,2.116,0,0,1,2.992,0l.008.009A2.113,2.113,0,0,1,22.63,14.869Z', 'M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M11.25,13.5a5.25,5.25,0,0,0-10.5,0v2.25H3l.75,7.5h4.5L9,15.75h2.25Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.284-.71']],
  MultipleActionsFlash: ['multiple-actions-flash', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M20.25,9.75l-5.91,6.882a.375.375,0,0,0,.285.618H17.25v6l5.911-6.882a.375.375,0,0,0-.286-.618H20.25Z', 'M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M11.25,13.5a5.25,5.25,0,0,0-10.5,0v2.25H3l.75,7.5h4.5L9,15.75h2.25Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M19.017,7.519a4.5,4.5,0,0,0-5.9.771']],
  MultipleActionsInformation: ['multiple-actions-information', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M10.555,10.888A5.251,5.251,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5l.324-3.233', 'M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z', 'M17.25 20.25L17.25 17.25', 'M17.25 14.31L17.25 14.31', 'M17.25,14.31a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsLaptop: ['multiple-actions-laptop', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21.9,12.75v6H11.4v-6a1.5,1.5,0,0,1,1.5-1.5h7.5A1.5,1.5,0,0,1,21.9,12.75Z', 'M11.4,18.75H21.9l1.171,3.513a.75.75,0,0,1-.711.987H10.936a.751.751,0,0,1-.712-.987Z', 'M3.145 3.750 A3.000 3.000 0 1 0 9.145 3.750 A3.000 3.000 0 1 0 3.145 3.750 Z', 'M9.146,9.191A5.251,5.251,0,0,0,.9,13.5v2.25h2.25l.75,7.5h3', 'M14.020 3.375 A2.625 2.625 0 1 0 19.270 3.375 A2.625 2.625 0 1 0 14.020 3.375 Z', 'M20.542,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsKey: ['multiple-actions-key', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15.576,18.924a.375.375,0,1,1-.531,0,.377.377,0,0,1,.531,0', 'M19.087,17.709l3.688-3.687a1.624,1.624,0,0,0-2.3-2.3l-3.687,3.688a4.06,4.06,0,1,0,2.3,2.3Z', 'M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M11.25,14.25V13.5a5.25,5.25,0,0,0-10.5,0v2.25H3l.75,7.5h4.5l.387-3.862', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsMobilephone: ['multiple-actions-mobilephone', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M19.5,19.875a.375.375,0,1,1-.375.375.374.374,0,0,1,.375-.375', 'M15.750 11.250 L23.250 11.250 L23.250 23.250 L15.750 23.250 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71', 'M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M11.25,13.5a5.25,5.25,0,0,0-10.5,0v2.25H3l.75,7.5h4.5L9,15.75h2.25Z']],
  MultipleActionsMail: ['multiple-actions-mail', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,15.75v6a1.5,1.5,0,0,1-1.5,1.5h-9a1.5,1.5,0,0,1-1.5-1.5v-6', 'M23.25,15.75a1.5,1.5,0,0,0-1.5-1.5h-9a1.5,1.5,0,0,0-1.5,1.5L16.455,19a1.5,1.5,0,0,0,1.59,0Z', 'M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M10.743,11.245A5.251,5.251,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5L8.436,21.4', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsPlayer: ['multiple-actions-player', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.250 11.250 L23.250 11.250 L23.250 23.250 L11.250 23.250 Z', 'M15.75,17.25V15.43a.431.431,0,0,1,.652-.369l3.033,1.82a.429.429,0,0,1,0,.737L16.4,19.438a.43.43,0,0,1-.652-.368Z', 'M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M9.174,9.317A5.251,5.251,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5L8.7,18.713', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsMonitor: ['multiple-actions-monitor', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.250 11.250 L23.250 11.250 L23.250 20.250 L11.250 20.250 Z', 'M14.25 23.25L20.25 23.25', 'M17.25 23.25L17.25 20.25', 'M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M8.251,8.755A5.254,5.254,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5l.324-3.233', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsShare1: ['multiple-actions-share-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 14.25L0.75 23.25', 'M.75,21.75h15a3,3,0,0,0-3-3H9a3,3,0,0,0-3-3H.75', 'M6 18.75L9 18.75', 'M15.000 3.750 A3.000 3.000 0 1 0 21.000 3.750 A3.000 3.000 0 1 0 15.000 3.750 Z', 'M18,23.25h2.25l.75-7.5h2.25V13.5a5.25,5.25,0,0,0-10.5,0v2.25H15', 'M4.875 3.375 A2.625 2.625 0 1 0 10.125 3.375 A2.625 2.625 0 1 0 4.875 3.375 Z', 'M3.6,9a4.5,4.5,0,0,1,7.284-.71']],
  MultipleActionsVideo: ['multiple-actions-video', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,15.75l-3,1v-1a1.5,1.5,0,0,0-1.5-1.5h-6a1.5,1.5,0,0,0-1.5,1.5v6a1.5,1.5,0,0,0,1.5,1.5h6a1.5,1.5,0,0,0,1.5-1.5v-1l3,1Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71', 'M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M10.309,10.5a5.25,5.25,0,0,0-9.559,3v2.25H3l.75,7.5h4.5L8.775,18']],
  MultipleActionsTime: ['multiple-actions-time', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M10.555,10.888A5.251,5.251,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5l.324-3.233', 'M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z', 'M19.902 17.25L17.25 17.25 17.25 14.598', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsUpload: ['multiple-actions-upload', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M10.555,10.888A5.251,5.251,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5l.324-3.233', 'M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z', 'M17.25 20.25L17.25 14.25', 'M17.25 14.25L15 16.5', 'M17.25 14.25L19.5 16.5', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsShield: ['multiple-actions-shield', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,15.75a7.668,7.668,0,0,1-6,7.5,7.669,7.669,0,0,1-6-7.5v-3a1.5,1.5,0,0,1,1.5-1.5h9a1.5,1.5,0,0,1,1.5,1.5Z', 'M17.25 15L17.25 19.5', 'M15 17.25L19.5 17.25', 'M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M9.174,9.317A5.251,5.251,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5L8.7,18.713', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsStar: ['multiple-actions-star', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M10.743,11.245A5.251,5.251,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5l.522-5.216', 'M17.947,11.68,19.489,15h3a.735.735,0,0,1,.518,1.283l-2.6,2.562,1.443,3.314a.786.786,0,0,1-1.119.982L17.24,21.183l-3.487,1.961a.786.786,0,0,1-1.119-.982l1.443-3.314-2.6-2.562A.734.734,0,0,1,11.989,15h3l1.544-3.323A.8.8,0,0,1,17.947,11.68Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsAlarm: ['multiple-actions-alarm', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18,12a3.749,3.749,0,0,1,3.75,3.75v3a1.5,1.5,0,0,0,1.5,1.5H12.75a1.5,1.5,0,0,0,1.5-1.5v-3A3.75,3.75,0,0,1,18,12Z', 'M18,22.5a.375.375,0,1,1-.375.375A.374.374,0,0,1,18,22.5', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71', 'M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M11.25,13.5a5.25,5.25,0,0,0-10.5,0v2.25H3l.75,7.5h4.5L9,15.75h2.25Z']],
  MultipleActionsBlock: ['multiple-actions-block', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M10.555,10.888A5.251,5.251,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5l.323-3.233', 'M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z', 'M13.008 21.491L21.492 13.008', 'M13.871 3.375 A2.625 2.625 0 1 0 19.121 3.375 A2.625 2.625 0 1 0 13.871 3.375 Z', 'M20.392,9a4.5,4.5,0,0,0-7.284-.71']],
  MultipleActionsCheck1: ['multiple-actions-check-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M10.555,10.888A5.251,5.251,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5l.323-3.233', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71', 'M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z', 'M19.924,15.505l-2.905,3.874a.751.751,0,0,1-1.131.08l-1.5-1.5']],
  MultipleActionsImage: ['multiple-actions-image', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.250 11.250 L23.250 11.250 L23.250 23.250 L11.250 23.250 Z', 'M15.375,14.25a.375.375,0,1,1-.375.375.374.374,0,0,1,.375-.375', 'M23.25,21l-2.391-3.587a.749.749,0,0,0-1.238-.014l-2,2.851-1.236-.989a.749.749,0,0,0-1.092.169L12.75,23.25', 'M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M9.751,9.826a5.251,5.251,0,0,0-9,3.674v2.25H3l.75,7.5h4.5l.387-3.862', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsMusic: ['multiple-actions-music', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.000 21.375 A1.875 1.875 0 1 0 15.750 21.375 A1.875 1.875 0 1 0 12.000 21.375 Z', 'M19.500 19.125 A1.875 1.875 0 1 0 23.250 19.125 A1.875 1.875 0 1 0 19.500 19.125 Z', 'M15.75,21.375V14.581a1.5,1.5,0,0,1,1.026-1.423l4.5-1.25a1.5,1.5,0,0,1,1.974,1.423v5.794', 'M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M11.2,12.749A5.251,5.251,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5l.2-2.015', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsRefresh: ['multiple-actions-refresh', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M10.555,10.888A5.251,5.251,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5', 'M15 18.75L11.25 18.75 11.25 22.5', 'M22.668,19.483a5.572,5.572,0,0,1-10.74-.733', 'M19.5 15.75L23.25 15.75 23.25 12', 'M11.833,15.017a5.572,5.572,0,0,1,10.74.733', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsSync: ['multiple-actions-sync', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M19.5 15.75L23.25 15.75 23.25 11.25', 'M23.061,15.75a6,6,0,1,0-1.121,5.242', 'M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M10.743,11.245A5.251,5.251,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5l.522-5.216', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsWarning: ['multiple-actions-warning', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.25 20.25L17.25 20.25', 'M17.25,20.25a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375', 'M17.25 18L17.25 15', 'M23.063,20.682a1.774,1.774,0,0,1-1.587,2.568H13.024a1.774,1.774,0,0,1-1.586-2.568l4.226-8.452a1.774,1.774,0,0,1,3.173,0Z', 'M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M11.25,14.25V13.5a5.25,5.25,0,0,0-10.5,0v2.25H3l.75,7.5h4.5l.387-3.862', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsRemove: ['multiple-actions-remove', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z', 'M19.5 15L15 19.5', 'M15 15L19.5 19.5', 'M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M10.555,10.888A5.251,5.251,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5l.323-3.233', 'M13.873 3.375 A2.625 2.625 0 1 0 19.123 3.375 A2.625 2.625 0 1 0 13.873 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsView: ['multiple-actions-view', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M9.675,9.75A5.251,5.251,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5L8.536,20.4', 'M10.500 15.750 A5.250 5.250 0 1 0 21.000 15.750 A5.250 5.250 0 1 0 10.500 15.750 Z', 'M23.25 23.25L19.463 19.462', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsAddress: ['multiple-actions-address', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15.000 17.250 A2.250 2.250 0 1 0 19.500 17.250 A2.250 2.250 0 1 0 15.000 17.250 Z', 'M19.5,17.25v1.125a1.874,1.874,0,0,0,1.875,1.875h0a1.874,1.874,0,0,0,1.875-1.875v-.847a6.185,6.185,0,0,0-5.845-6.276,6,6,0,0,0-1.577,11.835,6.14,6.14,0,0,0,2.966-.038', 'M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M10.555,10.888A5.251,5.251,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5l.323-3.232', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsHeart: ['multiple-actions-heart', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M10.743,11.245A5.251,5.251,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5l.522-5.216', 'M17.25,23.25l-5.113-5.335a3.025,3.025,0,0,1-.567-3.492h0a3.025,3.025,0,0,1,4.845-.787l.835.835.836-.835a3.025,3.025,0,0,1,4.845.787h0a3.025,3.025,0,0,1-.567,3.492Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsSetting: ['multiple-actions-setting', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M9.675,9.75A5.251,5.251,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5l.522-5.216', 'M15.750 16.500 A1.500 1.500 0 1 0 18.750 16.500 A1.500 1.500 0 1 0 15.750 16.500 Z', 'M18.525,10.7l.442,1.453a.993.993,0,0,0,1.173.681l1.473-.342a1.339,1.339,0,0,1,1.274,2.219l-1.03,1.111a1,1,0,0,0,0,1.362l1.03,1.111a1.338,1.338,0,0,1-1.274,2.218l-1.473-.341a.992.992,0,0,0-1.173.681L18.525,22.3a1.331,1.331,0,0,1-2.549,0l-.442-1.452a.992.992,0,0,0-1.173-.681l-1.473.341a1.338,1.338,0,0,1-1.274-2.218l1.03-1.111a1,1,0,0,0,0-1.362l-1.03-1.111a1.339,1.339,0,0,1,1.274-2.219l1.473.342a.993.993,0,0,0,1.173-.681l.442-1.453A1.331,1.331,0,0,1,18.525,10.7Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsChat: ['multiple-actions-chat', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21.75,20.25h-3l-4.5,3v-3h-1.5a1.5,1.5,0,0,1-1.5-1.5v-6a1.5,1.5,0,0,1,1.5-1.5h9a1.5,1.5,0,0,1,1.5,1.5v6A1.5,1.5,0,0,1,21.75,20.25Z', 'M14.25 14.25L20.25 14.25', 'M14.25 17.25L20.25 17.25', 'M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M9.1,9.264A5.251,5.251,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5l.259-2.594', 'M13.723 3.375 A2.625 2.625 0 1 0 18.973 3.375 A2.625 2.625 0 1 0 13.723 3.375 Z', 'M20.245,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsAdd: ['multiple-actions-add', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z', 'M17.25 14.25L17.25 20.25', 'M14.25 17.25L20.25 17.25', 'M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M10.555,10.888A5.251,5.251,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5l.323-3.233', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsMoney: ['multiple-actions-money', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M10.555,10.888A5.251,5.251,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5l.324-3.233', 'M18.75,14.25H16.717a1.341,1.341,0,0,0-.5,2.587l2.063.825a1.342,1.342,0,0,1-.5,2.588H15.75', 'M17.25 14.25L17.25 13.5', 'M17.25 21L17.25 20.25', 'M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsSubtract: ['multiple-actions-subtract', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.250 17.249 A6.000 6.000 0 1 0 23.250 17.249 A6.000 6.000 0 1 0 11.250 17.249 Z', 'M14.25 17.249L20.25 17.249', 'M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M10.555,10.888A5.251,5.251,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5l.323-3.233', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsWifi: ['multiple-actions-wifi', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.25,22.424a.375.375,0,1,1-.375.375.374.374,0,0,1,.375-.375', 'M23.25,15.622a9.542,9.542,0,0,0-12,0', 'M13.75,19.238a5.566,5.566,0,0,1,7,0', 'M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M10.555,10.888A5.251,5.251,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5l.324-3.233', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsCreditCard: ['multiple-actions-credit-card', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.250 14.250 L23.250 14.250 L23.250 23.250 L11.250 23.250 Z', 'M11.25 17.25L23.25 17.25', 'M17.25 20.25L20.25 20.25', 'M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M10.555,10.888A5.251,5.251,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5l.324-3.233', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsCoding: ['multiple-actions-coding', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z', 'M15.75 15.75L14.25 17.25 15.75 18.75', 'M18.75 15.75L20.25 17.25 18.75 18.75', 'M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M10.555,10.888A5.251,5.251,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5l.324-3.233', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsLock: ['multiple-actions-lock', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M14.250 15.750 L23.250 15.750 L23.250 23.250 L14.250 23.250 Z', 'M18.75,11.25h0a3,3,0,0,0-3,3v1.5h6v-1.5A3,3,0,0,0,18.75,11.25Z', 'M18.75 19.154L18.75 19.154', 'M18.75,19.154a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375', 'M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M11.25,13.5a5.25,5.25,0,0,0-10.5,0v2.25H3l.75,7.5h4.5L9,15.75h2.25Z', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsHome: ['multiple-actions-home', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.75,15.948v5.8a1.5,1.5,0,0,0,1.5,1.5h6a1.5,1.5,0,0,0,1.5-1.5v-5.8', 'M11.25,17.26l4.518-3.953a2.249,2.249,0,0,1,2.964,0L23.25,17.26', 'M18.75,23.25h-3v-3a1.5,1.5,0,0,1,3,0Z', 'M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M10.555,10.888A5.251,5.251,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5l.323-3.232', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsShare2: ['multiple-actions-share-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.250 18.000 A2.250 2.250 0 1 0 15.750 18.000 A2.250 2.250 0 1 0 11.250 18.000 Z', 'M18.750 21.000 A2.250 2.250 0 1 0 23.250 21.000 A2.250 2.250 0 1 0 18.750 21.000 Z', 'M18.750 13.500 A2.250 2.250 0 1 0 23.250 13.500 A2.250 2.250 0 1 0 18.750 13.500 Z', 'M15.425 16.845L19.075 14.655', 'M15.588 18.835L18.913 20.165', 'M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M11.2,12.749A5.251,5.251,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5l.2-2.015', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsUpDown: ['multiple-actions-up-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.25 20.25L14.25 23.25 17.25 20.25', 'M14.25 23.25L14.25 14.25', 'M17.25 17.25L20.25 14.25 23.25 17.25', 'M20.25 14.25L20.25 23.25', 'M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M10.743,11.245A5.251,5.251,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5l.522-5.216', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsGraduate: ['multiple-actions-graduate', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M16.5 14.308L9.75 17.087 16.5 19.558 23.25 17.087 16.5 14.308z', 'M9.75 17.066L9.75 20.837', 'M12.75,18.185V21.3a.75.75,0,0,0,.471.7l3,1.2a.748.748,0,0,0,.558,0l3-1.2a.75.75,0,0,0,.471-.7V18.185', 'M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M10.555,10.888A5.251,5.251,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsQuestion: ['multiple-actions-question', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M10.555,10.888A5.251,5.251,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5l.324-3.233', 'M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z', 'M15.375,16.125A1.875,1.875,0,1,1,17.25,18', 'M17.25 20.25L17.25 20.25', 'M17.25,20.25a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']],
  MultipleActionsText: ['multiple-actions-text', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.250 11.250 L23.250 11.250 L23.250 23.250 L11.250 23.250 Z', 'M14.25 14.25L20.25 14.25', 'M14.25 17.25L20.25 17.25', 'M14.25 20.25L16.5 20.25', 'M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M9.493,9.58A5.251,5.251,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5l.259-2.585', 'M13.875 3.375 A2.625 2.625 0 1 0 19.125 3.375 A2.625 2.625 0 1 0 13.875 3.375 Z', 'M20.4,9a4.5,4.5,0,0,0-7.285-.71']]
};
exports["default"] = _default;